<tt-page>
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-p2-setting-edit-form [params]="stateParams" (submit)="onSubmit()"></tt-p2-setting-edit-form>
        <tt-button-goto
            *ngIf="stateParams.p2_setting_keyno > '0'"
            ttText="p2_webpage_setting_edit"
            ttGoto="webpagesetting"
            [ttGotoParms]="{ argtype: 'p2_setting_keyno', argvalue: stateParams.p2_setting_keyno }"
        ></tt-button-goto>
    </tt-card>
</tt-page>
